import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Image } from 'react-bootstrap';
import Cooky from "../../cookie.svg";

const CookiePolicyFooter = ({hideFooter, overrideVisible}) => {
  const [showBanner, setShowBanner] = useState(overrideVisible || false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [otherCookies, setOtherCookies] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookiePreferences = localStorage.getItem('cookiePreferences');
    if (!cookiePreferences) {
      setShowBanner(true);
    } else {
        try {
            const parsed = JSON.parse(cookiePreferences);
            if (parsed.otherCookies) {
                setOtherCookies(true)
            }
        } catch (error) {
        }
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookiePreferences', JSON.stringify({ functional: true, other: true }));
    setShowBanner(false);
  };

  const handleCustomize = () => {
    setShowCustomize(true);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookiePreferences', JSON.stringify({ functional: true, other: otherCookies }));
    setShowBanner(false);
    setShowCustomize(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <>
      {/* Main Cookie Banner */}
      {!hideFooter && <div 
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          color: "#d9d9d9",
          background: `
          linear-gradient(to left top, #301081, #3a1178, #41146e, #451766, #471b5e)
          `,
          boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
          padding: '1rem',
          zIndex: 1050
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-8 mb-2 mb-md-0">
              <p className="mb-0">
              <Image src={Cooky} style={
                    {
                        maxWidth: "20px"
                    }
                } />{" "}We use cookies to improve your experience across our platform. 
                We provide full control to customize it anytime as per your preference. Refer to our <a style={{
                    color: "#52aaf2"
                }} href="https://beatbind.io/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> for more details.
              </p>
            </div>
            <div className="col-12 col-md-4 d-flex justify-content-end gap-2">
              <Button
              className='beat-btn-pr'
                variant="outline-primary"
                onClick={handleCustomize}
              >
                Customize
              </Button>
              <Button
                variant="primary"
                className='beat-btn-pr'
                onClick={handleAcceptAll}
              >
                Okay
              </Button>
            </div>
          </div>
        </div>
      </div>}

      {/* Customization Modal */}
      <Modal style={{
        color: "#d9d9d9",
        border: "none !important"
      }} show={showCustomize} onHide={() => setShowCustomize(false)}>
        <Modal.Header 
        style={{
            background: `
          linear-gradient(to left top, #301081, #3a1178, #41146e, #451766, #471b5e)
            `,
            borderBottom:"none",
            borderTopRightRadius: "0px",
            borderTopLeftRadius: "0px",
            color: "#d9d9d9"

        }}
        closeButton>
          <Modal.Title>Cookie Preferences</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{
            background: `
          linear-gradient(to left top, #301081, #3a1178, #41146e, #451766, #471b5e)
            `
        }}>
          <Form>
            <Form.Group className="mb-4">
              <Form.Check
                type="checkbox"
                id="functional-cookies"
                checked={true}
                disabled
                label={
                  <div>
                    <strong>Functional Cookies</strong>
                    <div className="small">
                      Required for functioning of BeatAI features
                    </div>
                  </div>
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Check
                type="checkbox"
                id="other-cookies"
                checked={otherCookies}
                onChange={(e) => setOtherCookies(e.target.checked)}
                label={
                  <div>
                    <strong>Other Cookies</strong>
                    <div className="small">
                      For improving and delivering tailored experience to you based on usage patterns.
                    </div>
                  </div>
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
        style={{
            background: `
          linear-gradient(to left top, #301081, #3a1178, #41146e, #451766, #471b5e)
            `,
            borderTop: "none",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
        }}
        >
          <Button 
          className='beat-btn-pr'
          variant="secondary" onClick={() => setShowCustomize(false)}>
            Cancel
          </Button>
          <Button
          className='beat-btn-pr'
          variant="primary" onClick={handleSavePreferences}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CookiePolicyFooter;